exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-tlist[data-v-44b54fea] {\n  border: none;\n}", ""]);

// exports
